import { type ReactNode, useCallback, useMemo, useReducer } from "react";
import { SideMenuContext } from "@/app/layouts/SideMenuContext";
import { reduceSideMenuOpen } from "@/app/layouts/sideMenuState";

interface SideMenuProviderProps {
  children: ReactNode;
}

export const SideMenuProvider: React.FunctionComponent<
  SideMenuProviderProps
> = ({ children }: SideMenuProviderProps) => {
  const [isSideMenuOpen, dispatch] = useReducer(reduceSideMenuOpen, false);
  const openSideMenu = useCallback((): void => dispatch("open"), []);
  const closeSideMenu = useCallback((): void => dispatch("close"), []);
  const value = useMemo(
    () => ({
      isSideMenuOpen,
      openSideMenu,
      closeSideMenu,
    }),
    [closeSideMenu, isSideMenuOpen, openSideMenu],
  );

  return (
    <SideMenuContext.Provider value={value}>
      {children}
    </SideMenuContext.Provider>
  );
};
